export const DEFAULT_OUTPUT_VOLUME = 85;

export function parseStoredOutputVolume(stored: string | null, fallback = DEFAULT_OUTPUT_VOLUME): number {
  if (stored === null || stored.trim() === "") return fallback;
  const parsed = Number(stored);
  return Number.isFinite(parsed) && parsed >= 0 && parsed <= 100 ? parsed : fallback;
}

export function outputVolumeToGain(percent: number): number {
  const normalized = Math.max(0, Math.min(100, percent)) / 100;
  return 1.5 * Math.pow(normalized, 1.35);
}